export const DeploymentStatus = {
	PRODUCTION: "production",
	QA: "qa",
	DEV: "dev",
	DEMO: "demo",
	MAINTENANCE: "maintenance",
};

export const DEPLOYMENT_STATUS_OPTIONS = [
	{ head: "Production", value: DeploymentStatus.PRODUCTION },
	{ head: "QA", value: DeploymentStatus.QA },
	{ head: "Dev", value: DeploymentStatus.DEV },
	{ head: "Demo", value: DeploymentStatus.DEMO },
	{ head: "Maintenance", value: DeploymentStatus.MAINTENANCE },
];

export const Tasks = {
	"RECOVER" : "RECOVER",
	"XOOK_ON" : "XOOK_ON",
	"XOOK_OFF" : "XOOK_OFF",
	"REPLENISH" : "REPLENISH",
	"PRIME_PREPARE" : "PRIME_PREPARE",
	"UNPRIME" : "UNPRIME",
	"CHANGE_SERVING_STATUS" : "CHANGE_SERVING_STATUS",
	"CHANGE_KITCHEN_STATUS" : "CHANGE_KITCHEN_STATUS"
}

const TaskStatus = {
	"IN_QUEUE" : 1,
	"IN_PROGRESS" : 2,
	"COMPLETED" : 3,
	"FAILED" : 4,
	"ABORTED"  : 5,
	"CANCELLED"  : 6
}